/** Claves localStorage FOOD — aisladas del shell cuando está embebido en D28D. */
const EMBEDDED = import.meta.env.VITE_FOOD_EMBEDDED === 'true';

export const FOOD_STORAGE_KEYS = {
  token: EMBEDDED ? 'food_access_token' : 'token',
  refresh: EMBEDDED ? 'food_refresh_token' : 'refreshToken',
  user: EMBEDDED ? 'food_user' : 'user',
  subscription: EMBEDDED ? 'food_subscription' : 'subscription',
};

export function getFoodStorageItem(key: keyof typeof FOOD_STORAGE_KEYS) {
  try {
    return localStorage.getItem(FOOD_STORAGE_KEYS[key]);
  } catch {
    return null;
  }
}

export function setFoodStorageItem(key: keyof typeof FOOD_STORAGE_KEYS, value: string | null) {
  try {
    const k = FOOD_STORAGE_KEYS[key];
    if (value == null) localStorage.removeItem(k);
    else localStorage.setItem(k, value);
  } catch { /* noop */ }
}

export function clearFoodSessionStorage() {
  for (const k of Object.values(FOOD_STORAGE_KEYS)) {
    try { localStorage.removeItem(k); } catch { /* noop */ }
  }
}
